import { render } from "./List.vue?vue&type=template&id=4b1331e5"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=4b1331e5&lang=scss"

import exportComponent from "F:\\Projeler\\vuejs\\eticposdashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__